// extracted by mini-css-extract-plugin
module.exports = {"error403":"_errors_error403__22z2W","error404":"_errors_error404__28b-Q"};